// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13G1O","label":"styles_label__3gfT8"};